import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: 'Ето защо да избереш Superhosting',
	blockDesc: 'Професионална поддръжка, бързо зареждане, сигурна инфраструктура и още!',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Екип от специалисти',
					text: 'Ние говорим твоя език. Екипът ни от хостинг експерти е това, което ни отличава. Приемаме успеха на бизнеса ти като наша кауза и се грижим за него, дори отвъд задълженията ни. Попитай за нас и ще се увериш!',
					buttonText: 'Професионална поддръжка',
					buttonAction: 'RedirectTo',
					buttonParams: [
						'/wp-support.php'
					],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '4,97 / 5,00',
					subtitle: 'максимална оценка от нашите клиенти',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '24 часа / 7 дни',
					subtitle: 'денонощна поддръжка',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '200 000 уебсайта',
					subtitle: 'над 200 000 уебсайта ни се доверяват',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '100% увереност',
					subtitle: 'експертна помощ по всяко време',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'Here’s why you should choose SuperHosting',
	blockDesc: 'Professional support, fast loading speeds, secure infrastructure, and more.',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'A team of experts',
					text: 'We speak your language. Our team of hosting specialists is what truly sets us apart. We treat your business success as our own mission and take care of it — even beyond our formal responsibilities. Ask around and see for yourself!',
					buttonText: 'Professional Support',
					buttonAction: 'RedirectTo',
					buttonParams: [
						'/wp-support.php'
					],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '4.97 / 5.00',
					subtitle: 'maximum customer rating',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '24 hours / 7 days',
					subtitle: 'round-the-clock support',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '200 000 websites',
					subtitle: 'trusted by over 200 000 websites',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '100% confidence',
					subtitle: 'expert help at any time',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];